import HeurekaSelectCategory from './SelectCategory';

export default HeurekaSelectCategory;


// WEBPACK FOOTER //
// ./src/modules/Heureka/SelectCategory/index.tsx